import { render, staticRenderFns } from "./recent-ribbons-settings.vue?vue&type=template&id=5efe6fbe&scoped=true"
import script from "./recent-ribbons-settings.vue?vue&type=script&lang=js"
export * from "./recent-ribbons-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efe6fbe",
  null
  
)

export default component.exports